import { get } from 'lodash'

import { ObjectDataRecord, TimeLineDTOType, TimeLineGroupedData } from '@types'

import { getKeyFieldY, getObjectXLinkToObjectYKey } from '../index'

// Функция для группировки списка данных ObjectX по каждому элементу данных ObjectY
export const groupObjectXListByObjectYElement = (
  config: TimeLineDTOType,
  objectYData: ObjectDataRecord[],
  objectXData: ObjectDataRecord[]
): TimeLineGroupedData[] => {
  // Создаём карту для быстрого доступа к списку objectXData по ключевому полю из элемента objectYData
  // Ключ - ключевое поле из ObjectYData, Значение - массив ObjectXData
  const xDataByYMap = new Map<string, ObjectDataRecord[]>()

  const xKeyField = getObjectXLinkToObjectYKey(config.objectX.linkToObjectY)

  const yKeyField = getKeyFieldY(config)

  // Заполняем карту сменами
  objectXData.forEach(xElement => {
    const xKeyValue = get(xElement, xKeyField)

    if (!xDataByYMap.has(xKeyValue)) {
      xDataByYMap.set(xKeyValue, [])
    }
    xDataByYMap.get(xKeyValue)!.push(xElement)
  })

  // Формируем результат
  return objectYData.map(yElement => {
    return {
      yElement,
      xArray: xDataByYMap.get(yElement[yKeyField]) || [],
    }
  })
}
